import React, { useEffect, useState } from "react";
import { useParams, Navigate } from "react-router-dom";
import { MembersApiRoutes } from "../../shared/api-routes/member/members-api.routes";
import http from "../../shared/utils/http";
import ProfilePage from "./ProfilePage";

const ProfileResolver: React.FC = () => {
	const params = useParams();
	const [accountType, setAccountType] = useState<string | null>(null);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(false);

	useEffect(() => {
		if (params.userId) {
			http
				.get(MembersApiRoutes.GET_USER(params.userId))
				.then((res) => {
					setAccountType(res.accountType);
					setLoading(false);
				})
				.catch((error) => {
					console.error("Error fetching user:", error);
					setError(true);
					setLoading(false);
				});
		}
	}, [params.userId]);

	if (loading) {
		return (
			<div style={{
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
				height: '100vh',
				backgroundColor: '#1a2332',
				color: 'white'
			}}>
				Loading...
			</div>
		);
	}

	if (error) {
		return (
			<div style={{
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
				height: '100vh',
				backgroundColor: '#1a2332',
				color: 'white'
			}}>
				User not found
			</div>
		);
	}

	// If accountType is "team", redirect to team page
	if (accountType === "team") {
		return <Navigate to={`/t/${params.userId}`} replace />;
	}

	// Otherwise, render the normal profile page
	return <ProfilePage />;
};

export default ProfileResolver;